var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: _vm.title,
        width: "1377px",
        height: "593px",
        top: "10vh",
      },
      on: { success: _vm.successFn },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "choose_resource",
        },
        [
          _c(
            "div",
            { staticClass: "window-search" },
            [
              [
                "0",
                "1",
                "2",
                "3",
                "4",
                "5",
                "51",
                "7",
                "10",
                "selectedRoundGoods",
              ].includes(_vm.currentId) && _vm.tearchSearch
                ? _c("span", { staticClass: "text" }, [_vm._v("IP")])
                : _vm._e(),
              [
                "0",
                "1",
                "2",
                "3",
                "4",
                "5",
                "51",
                "7",
                "10",
                "selectedRoundGoods",
              ].includes(_vm.currentId) && _vm.tearchSearch
                ? _c("TeacherSelect", {
                    ref: "teacherSelect",
                    staticClass: "m-r-20",
                    attrs: {
                      placeholder: "请选择IP",
                      "default-tearch-id": _vm.tearch.lecturerId,
                      value: _vm.tearch.lecturerName,
                    },
                    on: { selected: _vm.teacherSelect },
                  })
                : _vm._e(),
              [
                "0",
                "1",
                "2",
                "3",
                "4",
                "5",
                "51",
                "7",
                "10",
                "selectedRoundGoods",
              ].includes(_vm.currentId) && _vm.tearchSearch
                ? _c("m-select", {
                    staticClass: "m-r-20",
                    staticStyle: { width: "140px" },
                    attrs: {
                      clearable: false,
                      "dict-key": "singleLectureType",
                      size: "small",
                    },
                    model: {
                      value: _vm.singleLecture,
                      callback: function ($$v) {
                        _vm.singleLecture = $$v
                      },
                      expression: "singleLecture",
                    },
                  })
                : _vm._e(),
              _c(
                "div",
                { staticClass: "order-time-box" },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "input-with-select input-with-select-chang",
                      attrs: { placeholder: "请选择", size: "small" },
                      model: {
                        value: _vm.searchType,
                        callback: function ($$v) {
                          _vm.searchType = $$v
                        },
                        expression: "searchType",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "商品名称", value: 1 },
                      }),
                      _c("el-option", { attrs: { label: "商品ID", value: 2 } }),
                    ],
                    1
                  ),
                  _vm.searchType === 1
                    ? _c("el-input", {
                        staticClass: "filter_teacherSelect m-r-20",
                        staticStyle: { width: "160px" },
                        attrs: {
                          placeholder: "请输入商品名称",
                          clearable: "",
                          size: "small",
                        },
                        on: { clear: _vm.searchFn },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.searchFn.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.search,
                          callback: function ($$v) {
                            _vm.search =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "search",
                        },
                      })
                    : _c("el-input", {
                        staticClass: "filter_teacherSelect m-r-20",
                        staticStyle: { width: "160px" },
                        attrs: {
                          placeholder: "请输入商品id",
                          clearable: "",
                          size: "small",
                        },
                        on: { clear: _vm.searchFn },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.searchFn.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.searchGoodsId,
                          callback: function ($$v) {
                            _vm.searchGoodsId =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "searchGoodsId",
                        },
                      }),
                ],
                1
              ),
              _vm.showGradeTagFilter
                ? _c("AppGradeTagSelect", {
                    staticClass: "m-r-20",
                    attrs: {
                      options: _vm.gradeTagOptions,
                      "show-status-options": false,
                      width: "200px",
                      size: "small",
                      placeholder: "请选择交付年级标签",
                    },
                    on: { change: _vm.searchFn },
                    model: {
                      value: _vm.gradeTag,
                      callback: function ($$v) {
                        _vm.gradeTag = $$v
                      },
                      expression: "gradeTag",
                    },
                  })
                : _vm._e(),
              _vm.isSearchPrice &&
              ["0", "1", "2", "3", "4", "5", "7", "10"].includes(_vm.currentId)
                ? _c(
                    "div",
                    { staticClass: "moneyBox m-r-20" },
                    [
                      _c("span", { staticClass: "text" }, [_vm._v("价格")]),
                      _c("el-input-number", {
                        staticStyle: { width: "139px" },
                        attrs: {
                          size: "small",
                          placeholder: "请输入",
                          controls: false,
                        },
                        model: {
                          value: _vm.starSalePrice,
                          callback: function ($$v) {
                            _vm.starSalePrice = $$v
                          },
                          expression: "starSalePrice",
                        },
                      }),
                      _c("span", { staticClass: "m-l-10 m-r-10" }, [
                        _vm._v("-"),
                      ]),
                      _c("el-input-number", {
                        staticStyle: { width: "139px" },
                        attrs: {
                          size: "small",
                          placeholder: "请输入",
                          controls: false,
                        },
                        model: {
                          value: _vm.endSalePrice,
                          callback: function ($$v) {
                            _vm.endSalePrice = $$v
                          },
                          expression: "endSalePrice",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              ["A7"].includes(_vm.currentId) && _vm.showCourseType
                ? [
                    _c("span", { staticClass: "text" }, [_vm._v("课程标签")]),
                    _c(
                      "el-select",
                      {
                        staticClass: "m-r-20",
                        attrs: {
                          clearable: "",
                          placeholder: "请选择",
                          size: "small",
                        },
                        on: { clear: _vm.searchFn },
                        model: {
                          value: _vm.courseType,
                          callback: function ($$v) {
                            _vm.courseType = $$v
                          },
                          expression: "courseType",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "视频课", value: 0 },
                        }),
                        _c("el-option", {
                          attrs: { label: "训练营", value: 1 },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _c(
                "el-button",
                {
                  staticClass: "search_btn search_paramy",
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.searchFn },
                },
                [_vm._v("查询")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "search_btn",
                  attrs: { size: "small" },
                  on: { click: _vm.searchReset },
                },
                [_vm._v("重置")]
              ),
            ],
            2
          ),
          _vm.showGradeTag
            ? _c("div", { staticClass: "delay-grant-tip" }, [
                _vm._v(
                  " 当前大专栏已开启「延迟发放权益」，只能关联已配置交付年级标签的专栏，未打标签的专栏不可勾选 "
                ),
              ])
            : _vm._e(),
          _c("div", { staticClass: "window-tab" }, [
            _c(
              "div",
              { staticClass: "tab-wrapper" },
              [
                _c(
                  "el-tabs",
                  {
                    staticClass: "tab-item",
                    on: { "tab-click": _vm.changTab },
                    model: {
                      value: _vm.currentId,
                      callback: function ($$v) {
                        _vm.currentId = $$v
                      },
                      expression: "currentId",
                    },
                  },
                  _vm._l(_vm.tabList, function (item) {
                    return _c("el-tab-pane", {
                      key: item.id,
                      attrs: {
                        label: item.name,
                        name: item.id,
                        disabled: Boolean(item.disabled),
                      },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "tab-slort" },
              [
                _c("span", [_vm._v("排序：")]),
                _c("m-select", {
                  attrs: { "dict-key": "COMMODITY_SORT", size: "small" },
                  on: { change: _vm.handleSlortChage },
                  model: {
                    value: _vm.slort,
                    callback: function ($$v) {
                      _vm.slort = $$v
                    },
                    expression: "slort",
                  },
                }),
              ],
              1
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "window-list",
              class: { "with-grade-tip": _vm.showGradeTag },
            },
            [
              _c(
                "div",
                { staticClass: "resource-item-wrapper" },
                [
                  [
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5",
                    "6",
                    "10",
                    "99",
                    "selectedRoundGoods",
                  ].includes(_vm.currentId)
                    ? [
                        _c(
                          "div",
                          {
                            staticClass: "resource-item-wrapper-box",
                            class: { noMultiple: !_vm.multiple },
                          },
                          [
                            _vm.multiple
                              ? _c(
                                  "el-checkbox-group",
                                  {
                                    model: {
                                      value: _vm.checkList,
                                      callback: function ($$v) {
                                        _vm.checkList = $$v
                                      },
                                      expression: "checkList",
                                    },
                                  },
                                  _vm._l(_vm.tableData, function (item, index) {
                                    return _c(
                                      "el-checkbox",
                                      {
                                        key: item.goodsId,
                                        attrs: {
                                          label: item.goodsId,
                                          disabled:
                                            _vm.check.includes(item.goodsId) ||
                                            _vm.shouldDisableItem(item),
                                        },
                                        on: {
                                          change: (res) =>
                                            _vm.checkChange(res, item, index),
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "resource-item-wrapper-box-group",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "item-wrapper" },
                                              [
                                                _c("ImagePreviewer", {
                                                  staticClass:
                                                    "image-previewer",
                                                  attrs: {
                                                    src: item.coverVerticalUrl,
                                                    alt: "",
                                                    fit: "contain",
                                                  },
                                                }),
                                                _c(
                                                  "div",
                                                  { staticClass: "item-info" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "item-name-line",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "item-name",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.contentName
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm.showMultiSpecTag &&
                                                        _vm.isMultiSpec(item)
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "item-spec-count",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.multiSpecCount(
                                                                      item
                                                                    )
                                                                  ) + " 个规格"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "item-info-row2",
                                                      },
                                                      [
                                                        _vm.isPlaform
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "m-r-10",
                                                                staticStyle: {
                                                                  color: "#333",
                                                                  "line-height":
                                                                    "24px",
                                                                  "font-weight":
                                                                    "600",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item
                                                                      .tenantVO
                                                                      .tenantName +
                                                                      " "
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        item.saleType === 0
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "item-price m-r-10",
                                                              },
                                                              [_vm._v(" 免费 ")]
                                                            )
                                                          : _vm._e(),
                                                        item.saleType === 2
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "item-price m-r-10",
                                                              },
                                                              [_vm._v(" 加密 ")]
                                                            )
                                                          : _vm._e(),
                                                        [0, 1, 2].includes(
                                                          item.shelveFlag
                                                        )
                                                          ? _c(
                                                              "AppTag",
                                                              {
                                                                attrs: {
                                                                  "bg-color":
                                                                    _vm.getShelveFlagBgColor(
                                                                      item.shelveFlag
                                                                    ),
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "template",
                                                                  {
                                                                    slot: "icon",
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      class:
                                                                        _vm.getShelveFlagClass(
                                                                          item.shelveFlag
                                                                        ),
                                                                      style: {
                                                                        color: {
                                                                          0: "#00b42a",
                                                                          1: "#F53F3F",
                                                                          2: "#FF7D00",
                                                                        }[
                                                                          item
                                                                            .shelveFlag
                                                                        ],
                                                                      },
                                                                    }),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "template",
                                                                  {
                                                                    slot: "text",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        style: {
                                                                          color:
                                                                            {
                                                                              0: "#00b42a",
                                                                              1: "#F53F3F",
                                                                              2: "#FF7D00",
                                                                            }[
                                                                              item
                                                                                .shelveFlag
                                                                            ],
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            {
                                                                              0: "已上架",
                                                                              1: "已下架",
                                                                              2: "待上架",
                                                                            }[
                                                                              item
                                                                                .shelveFlag
                                                                            ]
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              2
                                                            )
                                                          : _vm._e(),
                                                        _vm.showGradeTagFilter
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "item-grade-tag item-price--right",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.gradeTagNames ||
                                                                      "--"
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _c("i", {
                                                          staticClass:
                                                            "item-row2-gap",
                                                        }),
                                                        _vm.showRangePrice(item)
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "item-price item-price--right",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "￥" +
                                                                    _vm._s(
                                                                      _vm.specPriceRange(
                                                                        item
                                                                      )
                                                                    )
                                                                ),
                                                              ]
                                                            )
                                                          : Number(
                                                              item.saleType
                                                            ) === 1
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "item-price item-price--right",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "￥" +
                                                                    _vm._s(
                                                                      _vm.formatPrice(
                                                                        item
                                                                      )
                                                                    )
                                                                ),
                                                              ]
                                                            )
                                                          : item.salePrice !==
                                                              undefined &&
                                                            item.salePrice !==
                                                              null &&
                                                            item.salePrice !==
                                                              ""
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "item-price item-price--right",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "￥" +
                                                                    _vm._s(
                                                                      _vm.formatPrice(
                                                                        item
                                                                      )
                                                                    )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                    _vm.selectSpec &&
                                                    _vm.isMultiSpec(item) &&
                                                    _vm.checkList.includes(
                                                      item.goodsId
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "spec-select-panel",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "spec-select-options",
                                                              },
                                                              _vm._l(
                                                                _vm.getSpecList(
                                                                  item
                                                                ),
                                                                function (sku) {
                                                                  return _c(
                                                                    "button",
                                                                    {
                                                                      key: _vm.getSpecKey(
                                                                        sku
                                                                      ),
                                                                      staticClass:
                                                                        "spec-option",
                                                                      class: {
                                                                        active:
                                                                          _vm.isSkuSelected(
                                                                            item,
                                                                            sku
                                                                          ),
                                                                        "spec-option--disabled":
                                                                          _vm.isSkuOutOfStock(
                                                                            sku
                                                                          ),
                                                                      },
                                                                      attrs: {
                                                                        type: "button",
                                                                        disabled:
                                                                          _vm.isSkuOutOfStock(
                                                                            sku
                                                                          ),
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            $event.stopPropagation()
                                                                            return _vm.handleSelectSku(
                                                                              item,
                                                                              sku
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.getSpecLabel(
                                                                            sku
                                                                          )
                                                                        ) +
                                                                          _vm._s(
                                                                            _vm.isSkuOutOfStock(
                                                                              sku
                                                                            )
                                                                              ? "（库存不足）"
                                                                              : ""
                                                                          )
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm.packagePrice
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "packageInputView",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "packageInputViewText",
                                                      },
                                                      [_vm._v("套餐单价")]
                                                    ),
                                                    _c("el-input-number", {
                                                      staticStyle: {
                                                        width: "262px",
                                                        "text-align": "left",
                                                      },
                                                      attrs: {
                                                        min: 0,
                                                        size: "small",
                                                        placeholder: "请输入",
                                                        controls: false,
                                                      },
                                                      model: {
                                                        value:
                                                          item.packagePrice,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "packagePrice",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.packagePrice",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    )
                                  }),
                                  1
                                )
                              : _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value: _vm.selectedSingleValue,
                                      callback: function ($$v) {
                                        _vm.selectedSingleValue = $$v
                                      },
                                      expression: "selectedSingleValue",
                                    },
                                  },
                                  _vm._l(_vm.tableData, function (item) {
                                    return _c(
                                      "el-radio",
                                      {
                                        key: item.goodsId,
                                        attrs: {
                                          label: item.goodsId,
                                          disabled:
                                            _vm.check.includes(item.goodsId) ||
                                            _vm.shouldDisableItem(item),
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "resource-item-wrapper-box-group",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "item-wrapper" },
                                              [
                                                _c("ImagePreviewer", {
                                                  staticClass:
                                                    "image-previewer",
                                                  attrs: {
                                                    src: item.coverVerticalUrl,
                                                    alt: "",
                                                    fit: "contain",
                                                  },
                                                }),
                                                _c(
                                                  "div",
                                                  { staticClass: "item-info" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "item-name-line",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "item-name",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.contentName
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm.showMultiSpecTag &&
                                                        _vm.isMultiSpec(item)
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "item-spec-count",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.multiSpecCount(
                                                                      item
                                                                    )
                                                                  ) + " 个规格"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "item-info-row2",
                                                      },
                                                      [
                                                        _vm.isPlaform
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "m-r-10",
                                                                staticStyle: {
                                                                  color: "#333",
                                                                  "line-height":
                                                                    "24px",
                                                                  "font-weight":
                                                                    "600",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item
                                                                      .tenantVO
                                                                      .tenantName +
                                                                      " "
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        item.saleType === 0
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "item-price m-r-10",
                                                              },
                                                              [_vm._v(" 免费 ")]
                                                            )
                                                          : _vm._e(),
                                                        item.saleType === 2
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "item-price m-r-10",
                                                              },
                                                              [_vm._v(" 加密 ")]
                                                            )
                                                          : _vm._e(),
                                                        [0, 1, 2].includes(
                                                          item.shelveFlag
                                                        )
                                                          ? _c(
                                                              "AppTag",
                                                              {
                                                                attrs: {
                                                                  "bg-color":
                                                                    _vm.getShelveFlagBgColor(
                                                                      item.shelveFlag
                                                                    ),
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "template",
                                                                  {
                                                                    slot: "icon",
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      class:
                                                                        _vm.getShelveFlagClass(
                                                                          item.shelveFlag
                                                                        ),
                                                                      style: {
                                                                        color: {
                                                                          0: "#00b42a",
                                                                          1: "#F53F3F",
                                                                          2: "#FF7D00",
                                                                        }[
                                                                          item
                                                                            .shelveFlag
                                                                        ],
                                                                      },
                                                                    }),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "template",
                                                                  {
                                                                    slot: "text",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        style: {
                                                                          color:
                                                                            {
                                                                              0: "#00b42a",
                                                                              1: "#F53F3F",
                                                                              2: "#FF7D00",
                                                                            }[
                                                                              item
                                                                                .shelveFlag
                                                                            ],
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            {
                                                                              0: "已上架",
                                                                              1: "已下架",
                                                                              2: "待上架",
                                                                            }[
                                                                              item
                                                                                .shelveFlag
                                                                            ]
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              2
                                                            )
                                                          : _vm._e(),
                                                        _vm.showGradeTagFilter
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "item-grade-tag",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "交付年级标签：" +
                                                                    _vm._s(
                                                                      item.gradeTagNames ||
                                                                        "--"
                                                                    )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _c("i", {
                                                          staticClass:
                                                            "item-row2-gap",
                                                        }),
                                                        _vm.showRangePrice(item)
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "item-price",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "￥" +
                                                                    _vm._s(
                                                                      _vm.specPriceRange(
                                                                        item
                                                                      )
                                                                    )
                                                                ),
                                                              ]
                                                            )
                                                          : Number(
                                                              item.saleType
                                                            ) === 1
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "item-price item-price--right",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "￥" +
                                                                    _vm._s(
                                                                      _vm.formatPrice(
                                                                        item
                                                                      )
                                                                    )
                                                                ),
                                                              ]
                                                            )
                                                          : item.salePrice !==
                                                              undefined &&
                                                            item.salePrice !==
                                                              null &&
                                                            item.salePrice !==
                                                              ""
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "item-price item-price--right",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "￥" +
                                                                    _vm._s(
                                                                      _vm.formatPrice(
                                                                        item
                                                                      )
                                                                    )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                    _vm.selectSpec &&
                                                    _vm.isMultiSpec(item) &&
                                                    _vm.checkList.includes(
                                                      item.goodsId
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "spec-select-panel",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "spec-select-options",
                                                              },
                                                              _vm._l(
                                                                _vm.getSpecList(
                                                                  item
                                                                ),
                                                                function (sku) {
                                                                  return _c(
                                                                    "button",
                                                                    {
                                                                      key: _vm.getSpecKey(
                                                                        sku
                                                                      ),
                                                                      staticClass:
                                                                        "spec-option",
                                                                      class: {
                                                                        active:
                                                                          _vm.isSkuSelected(
                                                                            item,
                                                                            sku
                                                                          ),
                                                                        "spec-option--disabled":
                                                                          _vm.isSkuOutOfStock(
                                                                            sku
                                                                          ),
                                                                      },
                                                                      attrs: {
                                                                        type: "button",
                                                                        disabled:
                                                                          _vm.isSkuOutOfStock(
                                                                            sku
                                                                          ),
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            $event.stopPropagation()
                                                                            return _vm.handleSelectSku(
                                                                              item,
                                                                              sku
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.getSpecLabel(
                                                                            sku
                                                                          )
                                                                        ) +
                                                                          _vm._s(
                                                                            _vm.isSkuOutOfStock(
                                                                              sku
                                                                            )
                                                                              ? "（库存不足）"
                                                                              : ""
                                                                          )
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm.packagePrice
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "packageInputView",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "packageInputViewText",
                                                      },
                                                      [_vm._v("套餐单价")]
                                                    ),
                                                    _c("el-input-number", {
                                                      staticStyle: {
                                                        width: "262px",
                                                        "text-align": "left",
                                                      },
                                                      attrs: {
                                                        min: 0,
                                                        size: "small",
                                                        placeholder: "请输入",
                                                        controls: false,
                                                      },
                                                      model: {
                                                        value:
                                                          item.packagePrice,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "packagePrice",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.packagePrice",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    )
                                  }),
                                  1
                                ),
                            _vm.tableData && _vm.tableData.length === 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "resource-item-wrapper-box-noData",
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/image/zanwusousuoneirong2.png"),
                                        alt: "",
                                      },
                                    }),
                                    _c(
                                      "div",
                                      { staticClass: "m-t-10 noDataText" },
                                      [_vm._v("暂无数据")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    : ["8", "9"].includes(_vm.currentId)
                    ? [
                        _c("div", { staticClass: "ss-material-main-tree" }, [
                          _c(
                            "div",
                            { staticClass: "ss-material-main-tree-left" },
                            [
                              _c("AppTree", {
                                directives: [
                                  {
                                    name: "loading",
                                    rawName: "v-loading",
                                    value: _vm.loading,
                                    expression: "loading",
                                  },
                                ],
                                staticStyle: { width: "200px" },
                                attrs: {
                                  loading: _vm.treeLoading,
                                  nobtn: true,
                                },
                                on: { "node-click": _vm.treeClick },
                                model: {
                                  value: _vm.classlist,
                                  callback: function ($$v) {
                                    _vm.classlist = $$v
                                  },
                                  expression: "classlist",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "ss-material-main-tree-right" },
                            [
                              _c(
                                "el-checkbox-group",
                                {
                                  model: {
                                    value: _vm.checkList,
                                    callback: function ($$v) {
                                      _vm.checkList = $$v
                                    },
                                    expression: "checkList",
                                  },
                                },
                                _vm._l(_vm.tableData, function (item, index) {
                                  return _c(
                                    "el-checkbox",
                                    {
                                      key: item.materialId,
                                      attrs: {
                                        label: item.materialId,
                                        disabled:
                                          _vm.check.includes(item.materialId) ||
                                          ([
                                            "Transcoding",
                                            "Uploading",
                                            "Checking",
                                          ].includes(item.status) &&
                                            item.transcodeProgress !== 100),
                                      },
                                      on: {
                                        change: (res) =>
                                          _vm.checkChange(res, item, index),
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "resource-item-wrapper-box-group",
                                          staticStyle: { width: "1067px" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "item-wrapper" },
                                            [
                                              _vm.currentId === "8"
                                                ? _c("img", {
                                                    staticStyle: {
                                                      width: "60px",
                                                      height: "60px",
                                                    },
                                                    attrs: {
                                                      src: item.materialFrameUrl,
                                                      alt: "",
                                                    },
                                                  })
                                                : _vm._e(),
                                              _vm.currentId === "9"
                                                ? _c("svg-icon", {
                                                    staticStyle: {
                                                      width: "60px",
                                                      height: "60px",
                                                      "font-size": "60px",
                                                    },
                                                    attrs: {
                                                      "class-name": "size-icon",
                                                      "icon-class": "audio",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.play(
                                                          _vm.row.materialUrl
                                                        )
                                                      },
                                                    },
                                                  })
                                                : _vm._e(),
                                              _c(
                                                "div",
                                                { staticClass: "item-info" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "item-name",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.materialName
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  [
                                                    "Transcoding",
                                                    "Uploading",
                                                    "Checking",
                                                  ].includes(item.status) &&
                                                  item.transcodeProgress !== 100
                                                    ? _c(
                                                        "div",
                                                        [
                                                          _vm._v(
                                                            " 视频解码中，解码完成" +
                                                              _vm._s(
                                                                item.transcodeProgress
                                                              ) +
                                                              "%，请解码成功再加入课程 "
                                                          ),
                                                          _c(
                                                            "el-button",
                                                            {
                                                              attrs: {
                                                                size: "mini",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleRefreshItem(
                                                                      item
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [_vm._v("刷新进度")]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                              _vm.tableData.length === 0
                                ? _c("div", { staticClass: "noData" }, [
                                    _vm._v("暂无数据"),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                      ]
                    : ["51"].includes(_vm.currentId)
                    ? [
                        _c(
                          "div",
                          {
                            staticClass: "resource-item-wrapper-box",
                            class: { noMultiple: !_vm.multiple },
                          },
                          [
                            _c(
                              "el-checkbox-group",
                              {
                                model: {
                                  value: _vm.checkList,
                                  callback: function ($$v) {
                                    _vm.checkList = $$v
                                  },
                                  expression: "checkList",
                                },
                              },
                              _vm._l(_vm.tableData, function (item, index) {
                                return _c(
                                  "el-checkbox",
                                  {
                                    key: item.specId,
                                    attrs: {
                                      label: item.specId,
                                      disabled:
                                        _vm.check.includes(item.specId) ||
                                        _vm.shouldDisableItem(item),
                                    },
                                    on: {
                                      change: (res) =>
                                        _vm.checkChange(res, item, index),
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "item-wrapper" },
                                      [
                                        _c("ImagePreviewer", {
                                          staticClass: "image-previewer",
                                          attrs: {
                                            src: item.contentUrl
                                              ? item.contentUrl.split(",")[0]
                                              : "",
                                            alt: "",
                                            fit: "contain",
                                          },
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "item-info" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "item-name" },
                                              [_vm._v(_vm._s(item.goodsName))]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "item-price" },
                                              [
                                                _c(
                                                  "el-tag",
                                                  { attrs: { size: "mini" } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item.specName)
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "item-price" },
                                              [
                                                _vm._v(
                                                  "￥" +
                                                    _vm._s(
                                                      _vm.formatPrice(item)
                                                    )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : ["7"].includes(_vm.currentId)
                    ? [
                        _c(
                          "div",
                          {
                            ref: "resourceItemWrapperBox",
                            staticClass: "resource-item-wrapper-box",
                            class: { noMultiple: !_vm.multiple },
                          },
                          [
                            _vm._l(_vm.tableData, function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: item.goodsId,
                                  staticClass: "packageCoure-check-view-group",
                                  attrs: {
                                    id:
                                      "packageCoure-check-view-group" +
                                      item.goodsId,
                                    label: item.goodsId,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "packageCoure-item-wrapper-box-group",
                                      on: {
                                        click: function ($event) {
                                          return _vm.onClickPackageCourse(
                                            item.goodsId,
                                            item,
                                            index
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "m-r-10" },
                                        [
                                          _c("el-checkbox", {
                                            attrs: {
                                              value: _vm.checkList.includes(
                                                item.goodsId
                                              ),
                                              disabled:
                                                _vm.check.includes(
                                                  item.goodsId
                                                ) ||
                                                _vm.shouldDisableItem(item),
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.onClickPackageCourse(
                                                  item.goodsId,
                                                  item,
                                                  index
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "packageCoure-item-wrapper",
                                        },
                                        [
                                          _c("ImagePreviewer", {
                                            staticClass: "image-previewer",
                                            attrs: {
                                              src: item.coverVerticalUrl,
                                              alt: "",
                                              fit: "contain",
                                            },
                                          }),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "packageCoure-item-info",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "item-name" },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.contentName)
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                  },
                                                },
                                                [
                                                  _vm.isPlaform
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass: "m-r-10",
                                                          staticStyle: {
                                                            color:
                                                              "rgb(51, 51, 51)",
                                                            "line-height":
                                                              "24px",
                                                            "font-weight":
                                                              "600",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.tenantVO
                                                                .tenantName +
                                                                " "
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  item.saleType === 0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "item-price m-r-10",
                                                        },
                                                        [_vm._v(" 免费 ")]
                                                      )
                                                    : _vm._e(),
                                                  item.saleType === 2
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "item-price m-r-10",
                                                        },
                                                        [_vm._v(" 加密 ")]
                                                      )
                                                    : _vm._e(),
                                                  item.saleType === 1
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "item-price m-r-10",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " ￥" +
                                                              _vm._s(
                                                                _vm.formatPrice(
                                                                  item
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  [0, 1, 2].includes(
                                                    item.shelveFlag
                                                  )
                                                    ? _c(
                                                        "AppTag",
                                                        {
                                                          attrs: {
                                                            "bg-color": {
                                                              0: "#E6F7EA",
                                                              1: "#FEECEC",
                                                              2: "#FFF2E6",
                                                            }[item.shelveFlag],
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "template",
                                                            { slot: "icon" },
                                                            [
                                                              _c("i", {
                                                                class: {
                                                                  0: "el-icon-success",
                                                                  1: "el-icon-error",
                                                                  2: "el-icon-time",
                                                                }[
                                                                  item
                                                                    .shelveFlag
                                                                ],
                                                                style: {
                                                                  color: {
                                                                    0: "#00b42a",
                                                                    1: "#F53F3F",
                                                                    2: "#FF7D00",
                                                                  }[
                                                                    item
                                                                      .shelveFlag
                                                                  ],
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "template",
                                                            { slot: "text" },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  style: {
                                                                    color: {
                                                                      0: "#00b42a",
                                                                      1: "#F53F3F",
                                                                      2: "#FF7D00",
                                                                    }[
                                                                      item
                                                                        .shelveFlag
                                                                    ],
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      {
                                                                        0: "已上架",
                                                                        1: "已下架",
                                                                        2: "待上架",
                                                                      }[
                                                                        item
                                                                          .shelveFlag
                                                                      ]
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        2
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      item.children && item.children.length > 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "packageCoure-item-wrapper-left",
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.onhandleOpen(item)
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "btn-left" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        item.childrenOpen
                                                          ? "收起"
                                                          : "展开"
                                                      )
                                                  ),
                                                  _c("i", {
                                                    class: item.childrenOpen
                                                      ? "el-icon-arrow-down"
                                                      : "el-icon-arrow-right",
                                                  }),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  item.childrenOpen
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "packageCoure-item-children",
                                        },
                                        _vm._l(item.children, function (c) {
                                          return _c(
                                            "div",
                                            {
                                              key: c.goodsId,
                                              staticClass:
                                                "packageCoure-item-wrapper-box-group",
                                              staticStyle: {
                                                padding: "18px 0px 0px 50px",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "packageCoure-item-wrapper",
                                                },
                                                [
                                                  _c("ImagePreviewer", {
                                                    staticClass:
                                                      "image-previewer",
                                                    attrs: {
                                                      src: c.coverVerticalUrl,
                                                      alt: "",
                                                      fit: "contain",
                                                    },
                                                  }),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "packageCoure-item-info",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "item-chidren-name",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "item-name",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  c.contentName
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          (c.goodsType === 3 ||
                                                            c.goodsType ===
                                                              4) &&
                                                          c.productCategory ===
                                                            0
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "item-chidren-type",
                                                                  staticStyle: {
                                                                    "margin-left":
                                                                      "15px",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "录播课"
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          (c.goodsType === 3 ||
                                                            c.goodsType ===
                                                              4) &&
                                                          c.productCategory ===
                                                            2
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "item-chidren-type",
                                                                  staticStyle: {
                                                                    "margin-left":
                                                                      "15px",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "线下课"
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          (c.goodsType === 3 ||
                                                            c.goodsType ===
                                                              4) &&
                                                          c.productCategory ===
                                                            1
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "item-chidren-type item-chidren-type-live",
                                                                  staticStyle: {
                                                                    "margin-left":
                                                                      "15px",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "训练营"
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "item-info-row2",
                                                        },
                                                        [
                                                          c.saleType === 0
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "item-price m-r-10",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " 免费 "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          c.saleType === 2
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "item-price m-r-10",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " 加密 "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          c.saleType === 1
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "item-price m-r-10",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " ￥" +
                                                                      _vm._s(
                                                                        _vm.formatPrice(
                                                                          c
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    : _vm._e(),
                                ]
                              )
                            }),
                            _vm.tableData && _vm.tableData.length === 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "resource-item-wrapper-box-noData",
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/image/zanwusousuoneirong2.png"),
                                        alt: "",
                                      },
                                    }),
                                    _c(
                                      "div",
                                      { staticClass: "m-t-10 noDataText" },
                                      [_vm._v("暂无数据")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]
                    : ["A7"].includes(_vm.currentId)
                    ? [
                        _c(
                          "div",
                          {
                            ref: "resourceItemWrapperBox",
                            staticClass: "resource-item-wrapper-box",
                          },
                          [
                            _vm._l(_vm.tableData, function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: item.goodsId,
                                  staticClass: "packageCoure-check-view-group",
                                  attrs: {
                                    id:
                                      "packageCoure-check-view-group" +
                                      item.goodsId,
                                    label: item.goodsId,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "packageCoure-item-wrapper-box-group",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "m-r-10",
                                          class: { noMultiple: !_vm.multiple },
                                        },
                                        [
                                          _c("el-checkbox", {
                                            attrs: {
                                              indeterminate:
                                                _vm.packageCoure_checkList[
                                                  item.goodsId
                                                ] &&
                                                _vm.packageCoure_checkList[
                                                  item.goodsId
                                                ].length > 0 &&
                                                _vm.packageCoure_checkList[
                                                  item.goodsId
                                                ].length !== item.liveCourseNum,
                                              value: _vm.ifCheckAll(item),
                                              disabled:
                                                item.liveCourseNum === 0 ||
                                                _vm.shouldDisableItem(item),
                                            },
                                            on: {
                                              change: (res) =>
                                                _vm.onClickPackageA7Course(
                                                  item.goodsId,
                                                  item,
                                                  index,
                                                  res
                                                ),
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "packageCoure-item-wrapper",
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              _vm.onClickPackageA7Course(
                                                item.goodsId,
                                                item,
                                                index,
                                                !_vm.ifCheckAll(item)
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("ImagePreviewer", {
                                            staticClass: "image-previewer",
                                            attrs: {
                                              src: item.coverVerticalUrl,
                                              alt: "",
                                              fit: "contain",
                                            },
                                          }),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "packageCoure-item-info",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "item-name" },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.contentName)
                                                  ),
                                                ]
                                              ),
                                              _vm.isPlaform
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        color: "#000",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.tenantVO
                                                            .tenantName + " "
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                  },
                                                },
                                                [
                                                  item.saleType === 0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "item-price m-r-10",
                                                        },
                                                        [_vm._v(" 免费 ")]
                                                      )
                                                    : _vm._e(),
                                                  item.saleType === 2
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "item-price m-r-10",
                                                        },
                                                        [_vm._v(" 加密 ")]
                                                      )
                                                    : _vm._e(),
                                                  item.saleType === 1
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "item-price m-r-10",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " ￥" +
                                                              _vm._s(
                                                                _vm.formatPrice(
                                                                  item
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  [0, 1, 2].includes(
                                                    item.shelveFlag
                                                  )
                                                    ? _c(
                                                        "AppTag",
                                                        {
                                                          attrs: {
                                                            "bg-color": {
                                                              0: "#E6F7EA",
                                                              1: "#FEECEC",
                                                              2: "#FFF2E6",
                                                            }[item.shelveFlag],
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "template",
                                                            { slot: "icon" },
                                                            [
                                                              _c("i", {
                                                                class: {
                                                                  0: "el-icon-success",
                                                                  1: "el-icon-error",
                                                                  2: "el-icon-time",
                                                                }[
                                                                  item
                                                                    .shelveFlag
                                                                ],
                                                                style: {
                                                                  color: {
                                                                    0: "#00b42a",
                                                                    1: "#F53F3F",
                                                                    2: "#FF7D00",
                                                                  }[
                                                                    item
                                                                      .shelveFlag
                                                                  ],
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "template",
                                                            { slot: "text" },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  style: {
                                                                    color: {
                                                                      0: "#00b42a",
                                                                      1: "#F53F3F",
                                                                      2: "#FF7D00",
                                                                    }[
                                                                      item
                                                                        .shelveFlag
                                                                    ],
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      {
                                                                        0: "已上架",
                                                                        1: "已下架",
                                                                        2: "待上架",
                                                                      }[
                                                                        item
                                                                          .shelveFlag
                                                                      ]
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        2
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      item.children
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "packageCoure-item-wrapper-left",
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.onhandleOpen(item)
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "btn-left" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        item.childrenOpen
                                                          ? "收起"
                                                          : "展开"
                                                      )
                                                  ),
                                                  _c("i", {
                                                    class: item.childrenOpen
                                                      ? "el-icon-arrow-down"
                                                      : "el-icon-arrow-right",
                                                  }),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  item.childrenOpen
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "packageCoure-item-children",
                                        },
                                        _vm._l(item.children, function (c) {
                                          return _c(
                                            "div",
                                            {
                                              key: c._goodsId,
                                              staticClass:
                                                "packageCoure-item-wrapper-box-group",
                                              staticStyle: {
                                                padding: "18px 0px 0px 25px",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "packageCoure-item-wrapper",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "m-r-10" },
                                                    [
                                                      _c("el-checkbox", {
                                                        attrs: {
                                                          value:
                                                            _vm.checkList.includes(
                                                              c._goodsId
                                                            ),
                                                          disabled:
                                                            !(
                                                              (c.goodsType ===
                                                                3 ||
                                                                c.goodsType ===
                                                                  4) &&
                                                              c.productCategory ===
                                                                1
                                                            ) ||
                                                            _vm.check.includes(
                                                              c._goodsId
                                                            ) ||
                                                            _vm.shouldDisableItem(
                                                              c
                                                            ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.onClickA7PackageCourse(
                                                              c._goodsId,
                                                              c,
                                                              index,
                                                              item
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c("ImagePreviewer", {
                                                    staticClass:
                                                      "image-previewer",
                                                    attrs: {
                                                      src: c.coverVerticalUrl,
                                                      alt: "",
                                                      fit: "contain",
                                                    },
                                                  }),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "packageCoure-item-info",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.onClickA7PackageCourse(
                                                            c._goodsId,
                                                            c,
                                                            index,
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "item-chidren-name",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "item-name",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  c.contentName
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          (c.goodsType === 3 ||
                                                            c.goodsType ===
                                                              4) &&
                                                          c.productCategory ===
                                                            0
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "item-chidren-type",
                                                                  staticStyle: {
                                                                    "margin-left":
                                                                      "15px",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "录播课"
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          (c.goodsType === 3 ||
                                                            c.goodsType ===
                                                              4) &&
                                                          c.productCategory ===
                                                            2
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "item-chidren-type item-chidren-type-offline",
                                                                  staticStyle: {
                                                                    "margin-left":
                                                                      "15px",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "线下课"
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          (c.goodsType === 3 ||
                                                            c.goodsType ===
                                                              4) &&
                                                          c.productCategory ===
                                                            1
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "item-chidren-type item-chidren-type-live",
                                                                  staticStyle: {
                                                                    "margin-left":
                                                                      "15px",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "训练营"
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                      _vm.isPlaform
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                color: "#000",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  c.tenantVO
                                                                    .tenantName +
                                                                    " "
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "item-info-row2",
                                                        },
                                                        [
                                                          c.saleType === 0
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "item-price m-r-10",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " 免费 "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          c.saleType === 2
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "item-price m-r-10",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " 加密 "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          c.saleType === 1
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "item-price m-r-10",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " ￥" +
                                                                      _vm._s(
                                                                        _vm.formatPrice(
                                                                          c
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    : _vm._e(),
                                ]
                              )
                            }),
                            _vm.tableData && _vm.tableData.length === 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "resource-item-wrapper-box-noData",
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/image/zanwusousuoneirong2.png"),
                                        alt: "",
                                      },
                                    }),
                                    _c(
                                      "div",
                                      { staticClass: "m-t-10 noDataText" },
                                      [_vm._v("暂无数据")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ]
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "dialogFooter",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "div",
            { staticClass: "flex" },
            [
              _vm.multiple
                ? _c(
                    "div",
                    { staticClass: "check-all" },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { disabled: _vm.disabledAllFn },
                          on: { change: _vm.handleCheckAll },
                          model: {
                            value: _vm.checkedAll,
                            callback: function ($$v) {
                              _vm.checkedAll = $$v
                            },
                            expression: "checkedAll",
                          },
                        },
                        [_vm._v("全选")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              !["A7"].includes(_vm.currentId)
                ? _c("el-pagination", {
                    attrs: {
                      layout: "jumper, prev, pager, next, sizes, total",
                      total: _vm.total,
                      "page-size": _vm.size,
                      "current-page": _vm.current,
                    },
                    on: {
                      "current-change": _vm.handleCurrentChange,
                      "size-change": _vm.handleSizeChange,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "dialogFooterRight" },
            [
              _c(
                "el-button",
                {
                  staticClass: "search_btn search_paramy",
                  attrs: { type: "primary", disabled: !_vm.hasSelectedGoods },
                  on: {
                    click: function ($event) {
                      return _vm.successFn()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.confirmText))]
              ),
              _c(
                "el-button",
                {
                  staticClass: "search_btn",
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }